import React from 'react'
import visionImg from '../../assets/aboutUs/1_About us.png'
import missionImg from '../../assets/aboutUs/2_About us.png'

const MissionVision = () => {
  return (
    <div className='h-fit lg:min-h-[100vh] lg:h-fit w-full bg-blue-bg bg-cover bg-center flex items-center justify-center py-16 lg:py-6' >
       <div className=' flex flex-col lg:flex-row gap-12 md:gap-24 items-center w-[90%] md:w-[70%] text-[#fff] ' >
          <div className='w-full lg:w-[50%] flex flex-col-reverse lg:flex-col items-center ' >
              <div className='flex flex-col gap-2'>
                <h1 data-aos="fade-right" data-aos-duration="800" className='text-7xl font-mosk700' >VISION</h1>
                <p data-aos="fade-right" data-aos-duration="950" className='text-lg lg:text-xl' >To be amongst the first choice for responsible organizations who seek a curated event experience driven by out-of-the-box thinking while being powered by systems and expertise, Globally.</p>
              </div>
              <img data-aos="zoom-in" className='h-[60vh]' src={visionImg} alt="" />

          </div>
          <div className='w-full lg:w-[50%] flex flex-col items-center '>
            <img data-aos="zoom-in" className='h-[40vh] lg:h-[50vh]' src={missionImg} alt="" />
              <div className='flex flex-col items-end gap-2' >
                <h1  data-aos="fade-left" data-aos-duration="800" className='text-7xl font-mosk700'>MISSION</h1>
                <p  data-aos="fade-left" data-aos-duration="900" className='text-lg lg:text-xl text-right'>To craft memorable experiences by providing creative, value-based event and campaign executions focused on the consumer.</p>
              </div>
          </div>
       </div>
    </div>
  )
}

export default MissionVision
